import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default display labels for the Order Cart component.
 */
export const defaultOrderCartDisplayText = {
    ticketDetails: '${quantity}x ${description}',
    removeItemButtonLabel: 'Remove item',
    actionButtonLabel: 'Next',
    ticketsSectionTitle: 'Tickets',
    ticketsSectionActionButtonLabel: 'Edit',
    itemsSectionTitle: 'Items',
    itemsSectionActionButtonLabel: 'Add more',
    itemModifierDetails: '${quantity}x ${description}'
};
export const orderCartDisplayTextValidator = Validator.object({
    ticketDetails: nonEmptyStringValidator,
    removeItemButtonLabel: nonEmptyStringValidator,
    actionButtonLabel: nonEmptyStringValidator,
    ticketsSectionTitle: nonEmptyStringValidator,
    ticketsSectionActionButtonLabel: nonEmptyStringValidator,
    itemsSectionTitle: nonEmptyStringValidator,
    itemsSectionActionButtonLabel: nonEmptyStringValidator,
    itemModifierDetails: nonEmptyStringValidator
});
